export default "__VITE_ASSET__BRBtzPIR__"